import ReducerUtils   from "../../../utils/ReducerUtils"
import Actions        from "../../../model/constant/actions"

const RetrievingPossibleAgents = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_PACY_POSSIBLE_AGENTS] : (state,action)=>action.status
})

export default RetrievingPossibleAgents
